<div id="date-scroller-body">
  <button mat-icon-button class="color-primary mic-icon-button-large" [ngClass]="{'disabled-btn': leftDisabled}" (click)="yearMinusOne()" [disabled]="leftDisabled">
    <mat-icon class="color-primary">chevron_left</mat-icon>
  </button>
  <div id="year-display">
    <mat-icon class="color-primary">calendar_month</mat-icon>
    <span class="color-primary">{{ year() }} - {{year() + 1}}</span>
  </div>
  <button mat-icon-button class="color-primary mic-icon-button-large" [ngClass]="{'disabled-btn': rightDisabled}" (click)="yearPlusOne()" [disabled]="rightDisabled">
    <mat-icon class="color-primary">chevron_right</mat-icon>
  </button>
</div>
